module.exports = __webpack_public_path__ + "static/media/down.b7ee616b.svg";